import { createUseStyles } from 'react-jss';

import styling from '../../services/styling';

export default createUseStyles(
  {
    caption: {
      textAlign: 'center',
      transform: 'scale(0.9)',
      marginTop: 36,
      [styling.breakpoints.up('md')]: {
        marginTop: 50,
      },
    },
    downloadPosters: {
      display: 'none',
      width: '100%',
      [styling.breakpoints.up('md')]: {
        display: 'block',
        margin: [70, 'auto', 280],
      },
    },
  },
  { name: 'home' },
);
